// extracted by mini-css-extract-plugin
module.exports = {"container":"EditIcon_container__Kb5qb","container__img":"EditIcon_container__img__Q8GGu"};